<template lang="html">
  <transition name="fade" enter-active-class="fadeInDown" mode="out-in">
    <section class="wcc section results-container" v-if="showResults">
      <h2>Results</h2>
      <ResultGroup>
        <Result :label="'Price'" :value="results.price"></Result>
        <Result :label="'Gross Commission'" :value="results.listingGrossCommissions"></Result>
        <Result :label="'GST'" :value="results.totalGst"></Result>
        <Result :label="'Total'" :value="results.total"></Result>
        <Result :label="'Seller Net Price'" :value="results.sellerNetPrice"></Result>
      </ResultGroup>
      <ResultGroup v-if="buyingAgentTotal">
        <hr>
        <h2>Buying Agent</h2>
        <Result :label="'Portion'" :value="results.buyingAgentPortion"></Result>
        <Result :label="'GST'" :value="results.buyingAgentGst"></Result>
        <Result :label="'Total'" :value="results.buyingAgentTotal"></Result>
      </ResultGroup>
      <ResultGroup v-if="listingAgentTotal">
        <hr>
        <h2>Listing Agent</h2>
        <Result :label="'Portion'" :value="results.listingAgentPortion"></Result>
        <Result :label="'GST'" :value="results.listingAgentGst"></Result>
        <Result :label="'Total'" :value="results.listingAgentTotal"></Result>
      </ResultGroup>
      <Buttons :calculatorData="calculatorData"></Buttons>
    </section>
  </transition>
</template>
<script>
  import Buttons from './_buttons.vue'
  import ResultGroup from './_resultGroup.vue' 
  import Result from './_result.vue'
  export default {
    props: ['calculatorData'],
    methods: {
      parseRoundedFloat(instance) {
        let float = parseFloat(instance.value)
        let multiplier = 2
        if (instance.decimalPlaces) {
          multiplier = 10 ** instance.decimalPlaces
        } else if (instance.value.indexOf) {
          multiplier = 10 ** (instance.value.length - instance.value.indexOf('.'))
        }
        return Math.round(float*multiplier)/multiplier
      },
      calculateCommission(commissionData) {
        if (commissionData) {
          if (commissionData.type == 'flat') {
            return Math.round(this.parseRoundedFloat(commissionData.rate) * this.price)/100
          } else if (commissionData.type == 'split') {
            let rate1 = this.parseRoundedFloat(commissionData.rate1)
            let threshold = this.parseRoundedFloat(commissionData.threshold)
            let rate2 = this.parseRoundedFloat(commissionData.rate2)
            if (this.price > threshold) {
              return Math.round((threshold * rate1 + (this.price - threshold) * rate2))/100
            } else {
              return Math.round(this.price * rate1)/100
            }
          } else {
            return 0
          }
        } else {
          return 0
        }
      },
      setResults(results) {
        this.calculatorData.results = results
      }
    },
    computed: {
      results() {
        let results = {
          price: this.price,
          listingGrossCommissions: this.listingGrossCommissions,
          listingAgentPortion: this.listingAgentPortion,
          listingAgentGst: this.listingAgentGst,
          listingAgentTotal: this.listingAgentTotal,
          buyingAgentPortion: this.buyingAgentPortion,
          buyingAgentGst: this.buyingAgentGst,
          buyingAgentTotal: this.buyingAgentTotal,
          totalGst: this.totalGst,
          total: this.total,
          sellerNetPrice: this.sellerNetPrice
        }
        this.setResults(results)
        return results
      },
      price() {
        return this.parseRoundedFloat(this.calculatorData.price)
      },
      listingGrossCommissions() {
        return this.calculateCommission(this.calculatorData.listingGrossCommissions.value)
      },
      buyingAgentCommission() {
        return this.calculateCommission(this.calculatorData.buyingAgentCommission.value)
      },
      buyingAgentBonus() {
        let buyingAgentCommission = this.calculatorData.buyingAgentCommission.value
        return buyingAgentCommission ? this.parseRoundedFloat(buyingAgentCommission.bonus) : 0
      },
      buyingAgentPortion() {
        return Math.round((this.buyingAgentCommission + this.buyingAgentBonus)*100)/100
      },
      buyingAgentGst() {
        let salesTaxRate = this.parseRoundedFloat(this.calculatorData.salesTaxRate)
        let gst = this.buyingAgentPortion * salesTaxRate
        return Math.round(gst)/100
      },
      buyingAgentTotal() {
        return Math.round((this.buyingAgentPortion + this.buyingAgentGst)*100)/100
      },
      listingAgentPortion() {
        let show = this.listingGrossCommissions > 0 && this.buyingAgentCommission > 0
        return show ? Math.round((this.listingGrossCommissions - this.buyingAgentCommission)*100)/100 : 0
      },
      listingAgentGst() {
        let salesTaxRate = this.parseRoundedFloat(this.calculatorData.salesTaxRate)
        let gst = this.listingAgentPortion * salesTaxRate
        return Math.round(gst)/100
      },
      listingAgentTotal() {
        return Math.round((this.listingAgentPortion + this.listingAgentGst)*100)/100
      },
      subtotal() {
        if (this.listingGrossCommissions > 0 && this.buyingAgentPortion > 0) {
          return Math.round((this.buyingAgentPortion + this.listingAgentPortion)*100)/100
        } else if (this.listingGrossCommissions > 0) {
          return this.listingGrossCommissions
        } else {
          return 0
        }
      },
      totalGst() {
        if (this.listingAgentGst > 0 && this.buyingAgentGst > 0) {
          return Math.round((this.listingAgentGst + this.buyingAgentGst)*100)/100
        } else if (this.listingGrossCommissions > 0) {
          let salesTaxRate = this.parseRoundedFloat(this.calculatorData.salesTaxRate)
          let gst = this.subtotal * salesTaxRate
          return Math.round(gst)/100
        } else {
          return 0
        }
      },
      total() {
        return Math.round((this.subtotal + this.totalGst)*100)/100
      },
      sellerNetPrice() {
        let show = this.listingGrossCommissions && this.buyingAgentPortion
        return show ? Math.round((this.price - this.total)*100)/100 : 0
      },
      showResults() {
        if (this.results.price > 0) {
          if (this.listingGrossCommissions > 0) {
            return true
          } else if (this.buyingAgentPortion > 0){
            return true
          }
        }
        return false
      }
    },
    mounted() {
      this.$ga.event('results', 'provided', 'westmar', true)
    },
    components: {
      Buttons,
      ResultGroup,
      Result
    }
  }
</script>
<style lang="scss">
section.wcc.results-container {
  background-color: $blue-400 !important;
  color: white;
  width: 100%;
  padding: $spacing;
  user-select: text;
  h2, h3 {
    color: white;
    margin-top: 0;
  }
  hr {
    color: white;
    border: 1px solid $blue-200;
    margin: $spacing/1.5 0;
  }
  .buttons {
    margin-top: $spacing/2;
  }
  .wcc.results {
    margin-bottom: $spacing/2;
    p {
      margin-bottom: 0;
      margin-top: 0;
    }
  }
}
</style>